import { useEffect } from 'react';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import { AIMING_SITE_ARR } from '@/constants/blade';
import { roundFloat } from '@/utils/common';

const pointTopArr: any = [];

export default function AimingPoint() {
    const { t } = useLang('bladeroboticlawnmower');

    useEffect(() => {
        document.querySelectorAll('.ani-aiming a').forEach((domA) => {
            domA.addEventListener('click', (e) => {
                const dom: any = e.currentTarget;
                dom.parentNode.childNodes.forEach((domB: HTMLAnchorElement) => {
                    domB.className = 'base';
                });
                dom.className = 'base active';
                dom.children[0].children[0].style.cssText = `transform: translateY(0%)`;
            });
        });

        AIMING_SITE_ARR.forEach((item) => {
            const dom = document.querySelector(`#${item}`);
            const box = (dom as HTMLDivElement).getBoundingClientRect();
            pointTopArr.push(parseInt(box.top));
        });

        const scrollFn = () => {
            // if (clickFlag.current) return;
            const scrollTop = Math.ceil(window.pageYOffset);
            let index = 0;
            let percent = 0;

            // 当前active
            const len = AIMING_SITE_ARR.length;

            for (let i = 0; i < len - 1; i++) {
                const start = pointTopArr[i];
                const end = pointTopArr[i + 1];
                percent = 0;

                if (scrollTop >= start && scrollTop < end) {
                    index = i;
                    percent = roundFloat(((scrollTop - start) / (end - start)) * 100, 2);
                    break;
                }

                if (scrollTop > end) {
                    percent = 100;
                    index = len - 2;
                }
            }

            const nodeList = document.querySelectorAll('.ani-aiming a');
            nodeList.forEach((item) => {
                item.className = 'base';
            });

            nodeList[index].className = 'base active';

            // 当前百分比
            nodeList[index].children[0].children[0].style.cssText = `transform: translateY(${percent}%)`;
        };

        // 监听滚动条
        document.addEventListener('scroll', scrollFn);

        return () => {
            document.removeEventListener('scroll', scrollFn);
        };
    }, []);

    return (
        <div className={`${css['aiming-point']} ani-aiming`}>
            <a className="base active" href="#robots">
                <span>
                    <span className="sliver"></span>
                </span>
                <em>{t('detail.aiming_point_1')}</em>
            </a>
            <a className="base" href="#bound">
                <span>
                    <span className="sliver"></span>
                </span>
                <em>{t('detail.aiming_point_2')}</em>
            </a>
            <a className="base" href="#mowing">
                <span>
                    <span className="sliver"></span>
                </span>
                <em>{t('detail.aiming_point_3')}</em>
            </a>
            <a className="base" href="#cut">
                <span>
                    <span className="sliver"></span>
                </span>
                <em>{t('detail.aiming_point_4')}</em>
            </a>
            <a className="base" href="#character">
                <span>
                    <span className="sliver"></span>
                </span>
                <em>{t('detail.aiming_point_5')}</em>
            </a>
            <a className="base" href="#services">
                <span>
                    <span className="sliver"></span>
                </span>
                <em>{t('detail.aiming_point_6')}</em>
            </a>
        </div>
    );
}
